module.exports = __webpack_public_path__ + "img/code.0d680d16.svg";